import { useQuery } from "@tanstack/react-query";
import { getVersionManifest } from "./api";

/* The deployed version manifest is polled on this interval (ms) while open. */
const VERSION_POLL_INTERVAL_MS = 1000 * 60;

/**
 * useVersionManifest Query
 *
 * Polls the deployed version manifest so a newly published build can be detected
 * while the app stays open. Refetches on the interval and on window focus.
 * Disabled in the local dev server (no manifest is served) to avoid a reload
 * loop and 404 noise. QueryKey: ["version-manifest"]
 */
export const useVersionManifest = () => {
  return useQuery({
    queryKey: ["version-manifest"],
    queryFn: getVersionManifest,
    enabled: import.meta.env.PROD,
    refetchInterval: VERSION_POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
    staleTime: 0,
    retry: false,
  });
};
